<template>

  <div class="page_container">
      <div class="content_container">

<div class="update_time">更新日期：2025年01月17日</div>
<p>重要须知：</p>
<p>欢迎您使用郑州麟宁网络科技有限公司及其关联方（以下简称“净信”）提供的产品和服务!</p>
<p>为了更好地为您提供服务，在注册或使用净信提供的产品和服务之前，请您务必审慎阅读、充分理解本使用协议各条款内容。</p>
<p>如您未满18周岁，请您在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用“净信”软件及相关服务。</p>
<p>如您不同意本协议，这将导致净信无法为您提供完整的产品和服务，您可以选择停止使用。如您自主选择同意、注册或使用净信的软件及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他关联协议和规则（包括但不限于《隐私政策》）的约束。</p>
<div class="first_title">1. 协议范围</div>
<p>1.1 本使用协议是您与净信之间关于注册或使用净信提供的产品、服务所订立的协议，一方当事人是您，另一方当事人是净信。</p>
<p>1.2 净信背单词在官网（www.dayuanenglish.com/xiaoyuanbeidanci）或官方 app 产品发布的相关协议、业务规则等内容，视为本使用协议的补充。上述内容一经正式发布，即为本使用协议的组成部分，您同样应当遵守。</p>
<div class="first_title">2. 信息收集、使用与保护</div>
<p>2.1 您同意并授权净信为履行本协议之目的收集用户信息，这些信息包括您在注册账号时的邮箱、实名注册系统中的电话号码、身份证号码，注册完成后的头像、昵称信息，您账号下的学习数据以及在净信产品充值记录、购买记录、支付记录、系统操作记录、银行账号、第三方支付平台的账号、与净信进行联系的通信记录及内容等与您使用净信产品或服务相关的信息，及其他您在使用净信服务的过程中向净信提供或净信基于安全、用户体验优化等考虑而需收集的信息，净信对您的用户信息的收集将遵循本协议及相关法律的规定。</p>
<p>2.2 我们会按照如下规则使用收集的信息：</p>
<p>（1）根据我们收集的信息向您提供各项产品与服务，包括基础功能、消费功能等；</p>
<p>（2）根据您使用净信产品或服务的学习数据、偏好、习惯、消费等特征为您提供个性化服务。</p>
<p>（3）根据您使用净信产品与服务的频率和情况、故障信息、性能信息等分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合。</p>
<p>我们将会在本协议所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。</p>
<div class="first_title">3. 服务范围</div>
<p>3.1 净信通过网站、 app 等方式提供免费和付费的产品和服务。您知悉并同意:付费项目或付费标准的改变、调整是一种正常的商业行为，您不得因为付费项目或付费标准的改变、调整而要求希净信进行赔偿或补偿。</p>
<p>3.2 净信的产品与服务会分析您的学习数据，并以此向您提供单词记忆方案与建议，帮助您持久记忆。</p>
<div class="first_title">4. 账号管理和软件更新</div>
<p>4.1 在您使用净信产品与服务期间,我们可能会视具体情况为您提供相应的操作设置,以便您可以查询、删除、更正或撤回您的相关个人信息，或者通过净信产品提供的注销功能/客服入口注销该帐号及其所有信息。此外,我们还设置了帮助与反馈渠道,您的意见将会得到及时的处理。</p>
<p>4.2 为了改善您的体验、完善服务内容，净信将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取修改、功能强化、版本升级等形式）。</p>
<p>4.3 为了保证本软件及服务的安全性和功能的一致性，净信有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</p>
<div class="first_title">5. 权利义务声明</div>
<p>5.1 您公开发表在净信的产品中的内容将会被其他用户看到，因此，您应确保您发表的内容不会侵犯他人的权益，否则您应承担由此而引起的法律责任。</p>
<p>5.2 净信有权根据有权机关的要求或者净信自身的运营需求将您发表的内容变更为未公开状态或者禁止分享的状态。</p>
<p>5.3 净信尽最大努力保证您数据的安全。但是，不可抗拒的原因（包括且不限于自然灾害、战争、国家政策调整等）造成的您数据丢失、泄漏，净信不承担任何责任和赔偿。</p>
<p>5.4 对于您通过非正常手段（如使用外部工具修改数据、反编译等）使用净信而导致的数据损坏或丢失、软件不能使用等情况，净信有权拒绝提供任何修复性服务。如果您的非正常手段对净信造成巨大影响和经济损失，净信有权追究其法律责任。</p>
<p>5.5 净信有权对使用非正常手段谋取非正当利益的账号进行操作限制，该种限制可能包括冻结账号所有功能；如果您的非正常手段对净信造成巨大影响和经济损失，净信有权追究其法律责任。</p>
<p>5.6 内容分享功能是净信为持续提供更好的内容而提供的分享类服务。如果您滥用内容分享功能导致系统内容分享质量降低，净信有权对其账户进行限制，该种限制可能包括冻结账户所有功能。</p>
<div class="first_title">6. 用户行为规范</div>
<p>6.1 净信一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用净信帐号或功能帐号或本软件及服务制作、复制、发布、传播如下干扰净信正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：</p>
<p>（1）反对宪法所确定的基本原则的；</p>
<p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
<p>（3）损害国家荣誉和利益的；</p>
<p>（4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</p>
<p>（5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</p>
<p>（6）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
<p>（7）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
<p>（8）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
<p>（9）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
<p>（10）侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；</p>
<p>（11）使用夸张标题，内容与标题严重不符的；</p>
<p>（12）炒作绯闻、丑闻、劣迹等的；</p>
<p>（13）不当评述自然灾害、重大事故等灾难的；</p>
<p>（14）带有性暗示、性挑逗等易使人产生性联想的；</p>
<p>（15）展现血腥、惊悚、残忍等致人身心不适的；</p>
<p>（16）煽动人群歧视、地域歧视等的；</p>
<p>（17）宣扬低俗、庸俗、媚俗内容的；</p>
<p>（18）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；</p>
<p>（19）侵害未成年人合法权益或者损害未成年人身心健康的内容；</p>
<p>（20）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
<p>（21）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
<p>（22）以非法民间组织名义活动的；</p>
<p>（23）其他违反法律法规、政策及公序良俗、社会公德或干扰净信正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
<p>6.2 除非法律允许或净信书面许可，您使用本软件过程中不得从事下列行为：</p>
<p>（1）删除本软件及其副本上关于著作权的信息；</p>
<p>（2）对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</p>
<p>（3）对净信拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
<p>（4）对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经净信授权的第三方工具/服务接入本软件和相关系统；</p>
<p>（5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
<p>（6）通过非净信开发、授权的第三方软件、插件、外挂、系统，登录或使用净信软件及服务，或制作、发布、传播上述工具；</p>
<p>（7）自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；</p>
<p>（8）其他未经净信明示授权的行为。</p>
<div class="first_title">7. 知识产权</div>
<p>7.1 您在净信的产品上发表的具有独创性的内容，视为您同意净信免费地使用相应的著作权，包括但不限于复制权、信息网络传播权和改编权。净信可以通过提高您属性参数的方式对发表内容的您进行奖励。</p>
<p>7.2 您的内容被净信的产品公开发布之后，视为净信在行使上述的发表权和信息网络传播权，净信有权限制您对该内容的修改。但您有权将修改后的内容重新在净信的产品上发表。</p>
<p>7.3 由多人参与编辑而形成的内容，著作权归净信所有。由多人发表的内容而形成的内容，属于净信的汇编作品，净信享受该汇编作品的著作权。</p>
<p>7.4 净信提供的产品和服务中包含的标识、版面设计、排版方式、文本、图片、图形等均受著作权、商标权及其它法律保护，未经相关权利人（含净信及其他原始权利人）同意，上述内容均不得在任何平台被直接或间接发布、使用、出于发布或使用目的的改写或再发行，或被用于其他任何商业目的。</p>
<p>7.5 为了促进学习内容的分享和传播，您将其在净信产品上发表的全部内容，视为您授予净信免费的、非独家使用许可，同意净信将该内容用于净信自己的或合作方的各种形态的产品和服务上，包括但不限于网站以及发表的应用或其他互联网产品。上述使用许可包括但不限于发表、修改、改编、出版、翻译、衍生、商业性使用等；商业性使用包括但不限于汇编成出版物、植入广告、在不超过净信获得的权利的范围内授权第三方以相同方式使用等。</p>
<p>7.6 为了促进学习内容的分享和传播，您将其在净信产品上发表的全部内容，视为您同意净信的其他用户在净信的产品与服务的范围内免费地使用，包括下载、修改以及在不超过其被授权范围内分享给净信的其他用户。如您删除您发表的内容，净信会停止分享该内容，但之前已经下载该内容的用户有可能继续使用该内容。</p>
<p>7.7 第三方若出于非商业目的，将您在净信产品上发表的内容转载在净信产品之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在净信上使用的帐号名称），注明“摘抄于净信”，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系您获得单独授权，按照您规定的方式使用该内容。</p>
<p>7.8 您在净信产品上传或发表内容时，您应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，净信有权根据实际情况删除相关的内容，且有权追究您的法律责任。您在净信产品上传或发表内容给净信或任何第三方造成损失的，您应负责全额赔偿。</p>
<p>7.9 您在净信产品上传或发表的内容被其他用户修改的，净信有权根据修改的情况决定修改后内容的作者或著作权人，有权根据修改后的内容决定如何在原作者和修改者之间分配收益或奖励。</p>
<p>7.10 您修改其他用户在净信产品上传或发表的内容的，净信有权根据修改的情况决定修改后内容的作者或著作权人，有权根据修改后的内容决定如何在原作者和修改者之间分配收益或奖励。</p>
<p>7.11 如果任何第三方侵犯了您在使用净信产品与服务中相关的权利，您同意授权净信或净信指定的代理人代表净信自身或您对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且您同意在必要的情况下参与共同维权。</p>
<p>7.12 净信尊重并保护您及第三方的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用净信产品和服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，净信有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行处理并承担可能因此产生的全部法律责任；如因您的侵权行为导致净信及其关联方遭受损失的（包括但不限于经济、商誉等损失），您还应足额赔偿净信及其关联方的全部损失。</p>
<div class="first_title">8. 免责申明</div>
<p>8.1 您在净信发表的内容仅表明其个人的立场和观点，并不代表净信的立场或观点。您作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律责任。</p>
<p>8.2 您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。对于因不可抗力或净信不能控制的原因造成的网络服务中断或其它缺陷，净信不承担任何责任，但净信会将尽力减少因此而给您造成的损失和影响。</p>
<div class="first_title">9. 违约责任</div>
<p>9.1 您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容、评论及点赞、推荐等行为，以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。</p>
<p>9.2 如果净信发现或收到他人举报或投诉用户违反本协议约定的，净信有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规主体相关帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。</p>
<p>9.3 净信保留对严重违反本使用协议或者违反法律法规的用户进行功能限制或者停止服务的权利。如果您的非正常手段对第三方造成巨大影响和经济损失，第三方主张的任何索赔、要求或损失，您应当独立承担责任；净信和关联方因此遭受损失的，您也应当一并赔偿。</p>
<div class="first_title">10. 协议修改</div>
<p>10.1 根据互联网的发展和有关法律、法规及规范性文件的变化，或者因业务发展需要，净信有权对本使用协议的条款做出修改或变更。一旦本使用协议的内容发生变动，净信将会直接在本软件内、净信网站上公布修改之后的协议内容，该公布行为视为净信已经通知您修改内容。净信也可采用电子邮件、短信或站内私信的传送方式，提示您协议条款的修改、服务变更、或其它重要事项。</p>
<p>10.2 如果您不同意净信对本使用协议相关条款所做的修改及通过网络公布视为通知送达的方式，您有权并应当停止使用净信。如果您继续使用净信，则视为您接受净信对本使用协议相关条款所做的修改。</p>
<div class="first_title">11. 通知和送达</div>
<p>本使用协议的更新、净信的所有通知，均可通过网络公开的页面或链接、您手机短信、电子邮件或站内私信的方式进行。网络公开的页面或链接的发布之日、手机短信、电子邮件或站内私信的发送之日中，以较早的日期视为送达日。</p>
<div class="first_title">12. 个别条款的效力</div>
<p>如本使用协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，在此情况下，该无效或不具有执行力的部分将被最接近原条款意图的一项有效并可执行的条款所替代，并且本使用协议的其余条款仍应有效并且有约束力。</p>
<div class="first_title">13. 其他</div>
<p>13.1 您使用本软件即视为您已阅读并同意受本协议的约束。净信有权在必要时修改本协议条款。您可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。</p>
<p>13.2 本使用协议签订地为河南省郑州市金水区。</p>
<p>13.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
<p>13.4 若您和净信之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本使用协议签订地有管辖权的人民法院管辖。</p>
<p>13.5 本使用协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本使用协议涵义解释的依据。</p>
<p>13.6 您在使用净信产品或服务的过程中，如果对本协议有任何的疑义或建议，您可以通过净信产品提供的客服入口联系我们，我们将及时处理您的投诉及建议。</p>
        
        

      </div>



  </div>

  
 



  
  

  
    
  </template>
  
  <script setup >


 


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction:row;
    align-content: left;
    font-size: 0.4rem;
    align-items: left;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    line-height: 1.5;
    
  }

  .update_time{
    color: #999;
    font-size: 0.35rem;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    text-align: left; /* 确保左对齐 */
    
  }
  

  p{
    
    
    color: #333;
    margin: 0;
    padding: 0;
    text-align: left;
    margin-bottom: 0.15rem;
    
  }


  .first_title{
    font-size: 0.5rem;
    color: #333;
    font-weight: bold;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    text-align: left; /* 确保左对齐 */
  }

  .second_title{
    
    color: #333;
    font-weight: bold;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    text-align: left; /* 确保左对齐 */
  }
  

  

  






  </style>